import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';




const Header = () => (
	<header>

		<nav>


{/* <Link activeClassName={style.active} href="/">Home</Link>  &nbsp;&nbsp; */}

<div class="inf">HELLO FRENS, please enjoy this custom cut&sew hat made for all marines. <br/> 1 LINK for Hat or 40$, checkout and you will see ETH address. <br/> These are preorders, and production begins in about 3, and takes about 3 weeks.  <br/> email <a target="_blanks" href="mailto:yo@just.is">yo@just.is</a> or <a target="_blanks" href="https://twitter.com/fodasynthesis">dm on twitter</a> for any questions or concerns. 
<br/> please don't sue me Sergey, im jus tryna have more LINK so i can build my company with it. 
</div>
</nav>


	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js